"use client";

import React, { useEffect } from "react";
import styles from "./GoogleLoginButton.module.css";

const GoogleLoginButton = ({
  onSuccess,
  onError,
  buttonText = "Continue with Google",
  loading = false,
  loadingText = "Signing in...",
}) => {
  const openPopup = (header, url) => {
    const width = 600;
    const height = 600;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;
    window.open(url, header, `width=${width},height=${height},top=${top},left=${left}`);
  };

  const loginWithGoogle = () => {
    if (loading) return;
    const rt = encodeURIComponent(window.location.origin);
    openPopup("Google Login", `${process.env.APICLOUDFRONTURL}/google/auth?returnTo=${rt}`);
  };

  useEffect(() => {
    const onMessage = (e) => {
      if (e.origin !== process.env.APICLOUDFRONTURL) return;

      if (e.data?.type === "oauth-success") {
        // Sailthru vars.oauth.provider_name = google|apple; vars.oauth.authtype = oauth
        onSuccess?.(e.data.userData);
      }

      if (e.data?.type === "oauth-error") {
        onError?.(e.data.message || "OAuth login failed.");
      }
    };

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [onSuccess, onError]);

  return (
    <button
      className={`${styles.googleBtn} ${loading ? styles.disabled : ""}`}
      onClick={loginWithGoogle}
      disabled={loading}
    >
      {loading ? (
        <span className={styles.loader}></span> // 👈 show loader
      ) : (
        <img
          src="https://orion-uploads.s3.us-east-1.amazonaws.com/newsletter-promo/Google__G__logo.svg.webp"
          alt="Google logo"
        />
      )}
      {loading ? loadingText : buttonText}
    </button>
  );
};

export default GoogleLoginButton;
